<div class="container py-2">
  <!-- Request Off Header Card -->
  <div
    class="card bg-linear-gradient-purple text-white mb-4 shadow-sm border-0"
  >
    <div
      class="card-header d-flex justify-content-between align-items-center"
      data-bs-toggle="collapse"
      data-bs-target="#requestOffCollapse"
      style="cursor: pointer"
    >
      <h2 class="mb-0 fs-5">
        <i class="bi bi-calendar-x-fill me-2"></i>
        Request a Day Off
      </h2>
      <i class="bi bi-chevron-down"></i>
    </div>

    <div id="requestOffCollapse" class="collapse show">
      <div class="card-body py-4">
        <div>
          <strong>Important:</strong> Please submit time-off requests at least
          <strong>2 weeks in advance</strong>. All requests require management
          approval before being finalized.
        </div>
        <button
          class="btn btn-light btn-sm fw-semibold mt-3"
          (click)="loadMyRequests()"
        >
          <i class="bi bi-list-check me-2"></i>
          View Your Requests
        </button>
      </div>
    </div>
  </div>

  <!-- Custom Toast -->
  <div class="custom-toast" *ngIf="toastVisible" [ngClass]="toastType">
    {{ toastMessage }}
  </div>

  <!-- Calendar Grid -->
  <div class="calendar-wrapper mx-auto">
    <div class="calendar-header">
      <button class="btn btn-gradient me-2" (click)="prevMonth()">&lt;</button>
      <h4>{{ monthNames[currentMonth] }} {{ currentYear }}</h4>
      <button class="btn btn-gradient ms-2" (click)="nextMonth()">&gt;</button>
    </div>

    <div class="calendar-grid mt-3">
      <div class="day-header" *ngFor="let d of dayNames">{{ d }}</div>

      <div
        *ngFor="let day of daysInMonth"
        class="day-cell"
        [class.today]="day && isToday(day)"
        [class.holiday]="day && isHoliday(day)"
        (click)="day && openRequestModal(day)"
        [title]="day && isHoliday(day) ? isHoliday(day)!.name : ''"
      >
        <i
          *ngIf="day && isHoliday(day)"
          class="bi bi-star-fill holiday-icon"
        ></i>
        <span *ngIf="day" class="day-number">{{ day.getDate() }}</span>
      </div>
    </div>
  </div>

  <!-- Color Legend -->
  <div class="calendar-legend d-flex justify-content-center gap-4 mt-4">
    <div class="legend-item d-flex align-items-center">
      <span class="legend-dot bg-linear-gradient-purple me-2"></span>
      <small class="text-muted">Today</small>
    </div>
    <div class="legend-item d-flex align-items-center">
      <span class="legend-dot bg-warning me-2"></span>
      <small class="text-muted"
        >Holidays</small
      >
    </div>
  </div>

  <!-- Request Modal -->
  <div class="modal-backdrop" *ngIf="selectedDate">
    <div class="modal-content p-4 text-center">
      <h5 class="mb-3">Request Day Off</h5>
      <p>
        Would you like to request off for
        <strong>{{ selectedDate | date : "fullDate" }}</strong
        >?
      </p>
      <div
        *ngIf="isHoliday(selectedDate)"
        class="alert alert-warning mt-2 mb-3"
      >
        <i class="bi bi-star-fill me-2"></i>
        <strong>{{ isHoliday(selectedDate)!.name }}</strong>
      </div>
      <div class="d-flex justify-content-center gap-3 mt-3">
        <button class="btn btn-gradient" (click)="submitRequest()">
          Yes, Request Off
        </button>
        <button class="btn btn-secondary" (click)="selectedDate = null">
          Cancel
        </button>
      </div>
    </div>
  </div>

  <!-- My Requests Modal -->
  <div class="modal-backdrop" *ngIf="showMyRequestsModal">
    <div class="modal-content my-requests-modal p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="mb-0">Your Time-Off Requests</h5>
        <button
          class="btn-close"
          (click)="closeMyRequestsModal()"
          aria-label="Close"
        ></button>
      </div>

      <!-- Loading State -->
      <div *ngIf="loadingRequests" class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>

      <!-- Requests List -->
      <div
        *ngIf="!loadingRequests && myRequests.length > 0"
        class="requests-list"
      >
        <div *ngFor="let request of myRequests" class="request-card mb-3">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h6 class="mb-1">{{ request.date | date : "fullDate" }}</h6>
              <small class="text-muted"
                >Submitted: {{ request.createdAt | date : "short" }}</small
              >
            </div>
            <span
              class="badge"
              [ngClass]="{
                'bg-warning text-dark': request.status === 'pending',
                'bg-success': request.status === 'approved',
                'bg-danger': request.status === 'declined'
              }"
            >
              {{ request.status | titlecase }}
            </span>
          </div>
          <div *ngIf="request.approvedBy" class="mt-2">
            <small class="text-muted">
              <i class="bi bi-person-check me-1"></i>
              By: {{ request.approvedBy }}
            </small>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div
        *ngIf="!loadingRequests && myRequests.length === 0"
        class="text-center py-4 text-muted"
      >
        <i class="bi bi-inbox fs-1"></i>
        <p class="mt-2">You haven't submitted any time-off requests yet.</p>
      </div>

      <div class="text-end mt-3">
        <button class="btn btn-secondary" (click)="closeMyRequestsModal()">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
